import { getAdjustedDirection } from '../../../../utils/animationsUtils';
const name = 'ArcIn';
const properties = { schema: {} };
const paramsMap = {
    top: { idx: 0, rotationX: '80deg' },
    right: { idx: 1, rotationY: '80deg' },
    bottom: { idx: 2, rotationX: '-80deg' },
    left: { idx: 3, rotationY: '-80deg' },
};
const easingMap = {
    soft: { easing: 'cubicInOut' },
    medium: { easing: 'quintInOut' },
    hard: { easing: 'backOut' },
};
function animate(kit, elements, duration, delay, { direction = 'right', easing = 'quintInOut', power, ...params } = {}) {
    const sequence = kit.sequence(params);
    const ease = typeof power !== 'undefined' ? easingMap[power].easing : easing;
    sequence.add(kit.animate('BaseFade', elements, duration * 0.7, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'sineIn',
    }));
    elements.forEach((element) => {
        const elementAngleInDeg = Number(kit.engine.getProperty(element, '--comp-rotate-z') || 0);
        const { width, height } = kit.engine.getBoundingRect(element);
        const adjDirection = getAdjustedDirection(paramsMap, direction, elementAngleInDeg);
        const { rotationX = 0, rotationY = 0 } = paramsMap[adjDirection];
        const z = rotationX ? height / 2 : width / 2;
        sequence
            .add(kit.engine.set(element, { transformOrigin: `50% 50% -${z}px` }), 0)
            .add(kit.animate('BaseRotate3D', element, duration, delay, {
            perspective: 800,
            from: { rotationX, rotationY },
            ease,
        }), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=arcIn.js.map